import styled from "styled-components";
import globalStyles from "../../../constants/globalStyles/theme.json";

const { colors } = globalStyles;

export const Button = styled.button<{ $isOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 1px solid ${({ $isOpen }) => ($isOpen ? colors.primary.brown : colors.primary.green)};
  border-radius: 50%;
  background-color: ${({ $isOpen }) => ($isOpen ? colors.primary.brown : colors.primary.green)};
  color: ${colors.primary.offWhite};
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;

  &:hover {
    background-color: ${colors.primary.brown};
    border-color: ${colors.primary.brown};
  }

  &:active {
    transform: scale(0.94);
  }

  &:focus-visible {
    outline: 3px solid ${colors.primary.brown};
    outline-offset: 3px;
  }
`;

export const Line = styled.span<{ $isOpen?: boolean }>`
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 999px;
  background-color: ${colors.primary.offWhite};
  transition:
    transform 0.25s ease,
    opacity 0.2s ease;

  &:nth-child(1) {
    transform: ${({ $isOpen }) => ($isOpen ? "translateY(7px) rotate(45deg)" : "none")};
  }

  &:nth-child(2) {
    opacity: ${({ $isOpen }) => ($isOpen ? 0 : 1)};
  }

  &:nth-child(3) {
    transform: ${({ $isOpen }) => ($isOpen ? "translateY(-7px) rotate(-45deg)" : "none")};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
